<template>
  <div class="layout">
    <header>
      <div class="header-box">
        <p class="logo">
          智慧公交城乡一体化平台
        </p>
      </div>
    </header>
    <main class="login">
      <img
        src="../assets/background_logo.png"
        class="background" />
      <div class="form">
        <div class="title">
          <span>用户登录</span>
        </div>
        <AuthMultipleInput
          ref="username"
          v-model="username"
          type="autoComplete"
          label="手机号码"
          placeholder="手机号码"
          :maxlength="11"
          :search-data="accounts"
          :rule="[
            { required: true, message: `手机号码不能为空`, trigger: `blur` },
          ]"
          @keyup-enter="submit"
        ></AuthMultipleInput>
        <AuthMultipleInput
          ref="password"
          v-model="password"
          :type="isEyeShow ? 'text' : 'password'"
          label="密码"
          placeholder="密码"
          :maxlength="20"
          :rule="[{ required: true, message: `密码不能为空`, trigger: `blur` }]"
          @keyup-enter="submit"
        ></AuthMultipleInput>
        <div
          @click="isEyeShow = !isEyeShow"
          style="
            cursor: pointer;
            position: relative;
            top: -44px;
            right: -243px;
            width: 18px;
          "
        >
          <Icon
            type="ios-eye-outline"
            size="20"
            v-if="isEyeShow" />
          <Icon
            type="ios-eye-off-outline"
            size="20"
            v-else />
        </div>
        <div>
          <Button
            @click="submit"
            :loading="loading">
            登录
          </Button>
          <div class="form-bottom">
            <a
              @click="linkSetting"
              class="forgot-link">重置密码</a>
          </div>
        </div>
      </div>
    </main>
    <footer>Copyright © http://www.123cx.com, All Rights Reserved.</footer>
  </div>
</template>

<script>
import AuthMultipleInput from '@/components/auth-multiple-input.vue';
import pattern from '@/util/pattern';
import {login, querySmsSysConfig} from '@/service';
import {getCookieInfo, encrypt, setCookieInfo, getHistoryAccounts, addHistoryAccount} from '@/util';
import {validationFormat} from '../util/password';

export default {
  name: 'Login',
  components: {AuthMultipleInput},
  data() {
    return {
      pattern,
      loading: false,
      accounts: getHistoryAccounts(),
      username: '',
      password: '',
      isEyeShow: false,
    };
  },

  mounted() {
    const {token} = getCookieInfo();
    if (token) {
      this.$store.dispatch('user/init').then(() => {
        this.$router.push(`/`);
      });
    }
  },

  methods: {
    linkSetting() {
      querySmsSysConfig().then(({data}) => {
        if (data === 1) {
          this.$router.push({
            name: `findPwd`,
          });
        } else {
          this.$Message.info('请联系企业管理员进行重置密码');
        }
      });
    },
    submit() {
      Promise.all([
        this.$refs['username'].isValid(),
        this.$refs['password'].isValid(),
      ]).then(([v1, v2]) => {
        if (v1 && v2) {
          const username = this.$refs['username'].getOriginValue();
          const password = this.$refs['password'].getOriginValue();
          if (!validationFormat(password)) {
            return this.$Modal.info({
              title: '提示',
              content: '您的密码安全级别过低，请重置密码',
            });
          }
          this.loading = true;
          login({
            username,
            password: encrypt(password),
            deviceId: this.$store.getters['system/deviceId'],
            // eslint-disable-next-line camelcase
          }).then(({access_token, expires_in}) => {
            this.$Message.success('登录成功');
            setCookieInfo('123cx@token', access_token, expires_in);
            setCookieInfo('login-time', new Date().getTime(), expires_in);
            addHistoryAccount(username);
            const {redirect} = this.$route.query;
            const url = decodeURIComponent(`${redirect || ''}`);
            const urlPattern = /^(http(s)?:)?\/\/./i;
            if (!redirect || !urlPattern.test(url)) return this.$router.push(`/`);
            location.href = url;
          }, ({response: {data}}) => {
            this.$Message.error(data.error_description);
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  width: 100%;
  height: 100vh;
  min-width: 1400px;
  background: #ffffff;
  overflow: hidden;

  header {
    display: flex;
    height: 64px;
    width: 100%;
    margin-left: 28px;

    .header-box {
      display: flex;
      flex-direction: column;
      width: 300px;
      text-align-last: justify;
      text-align: center;
      text-justify: distribute-all-lines;
      justify-content: center;

      .logo {
        font-size: 26px;
        color: #3f3f3f;
      }

      .path {
        font-size: 10px;
        color: #979797;
        font-weight: 600;
      }
    }
  }

  .login {
    position: relative;
    display: flex;
    align-items: center;
    height: calc(100vh - 136px);
    min-height: 600px;
    width: 100%;
    background: url("../assets/login_background.jpg") no-repeat;
    background-size: 100% 100%;

    .background {
      position: absolute;
      right: 56%;
      width: 464px;
      height: 436px;
      margin-bottom: 80px;
    }

    .form {
      position: absolute;
      left: 56%;
      box-sizing: border-box;
      width: 360px;
      height: 408px;
      padding: 30px 48px 50px;
      margin-bottom: 80px;
      border-radius: 6px;
      box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.17);
      background: #ffffff;

      .title {
        color: #1890ff;
        font-size: 20px;
        margin-bottom: 56px;

        span {
          position: relative;

          &:before {
            position: absolute;
            bottom: -6px;
            content: "";
            width: 100%;
            height: 3px;
            background: #1890ff;
            border-radius: 2px;
          }
        }
      }

      button {
        height: 38px;
        background: linear-gradient(
          270deg,
          rgba(24, 144, 255, 1) 0%,
          rgba(24, 144, 255, 1) 100%
        );
        border-radius: 4px;
        font-size: 14px;
        color: #fff;
        border: 0;
        outline: 0;
        width: 100%;
        margin-top: 8px;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }

      .form-bottom {
        margin-top: 12px;
        text-align: right;

        .forgot-link {
          color: #1890ff;
          text-decoration: none;
        }
      }
    }
  }

  footer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 72px;
    width: 100%;
    font-size: 11px;
    font-weight: 600;
    color: #979797;
  }
}
</style>
